/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './AppFatTeams';
import * as Queries from './AppFatTeams.dfc.new';
import type { AdditionalContextArgs } from './AppFatTeams.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetByHubQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetByHubResponseType>,
    References.GetByHubRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getByHub', References.GetByHubResponseType>
        : References.GetByHubResponseType)
    | undefined;
};

export function useGetByHubQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetByHubResponseType>,
    References.GetByHubRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByHubQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_BY_HUB_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByHub: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetByHubQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetByHubQueryReturn<T>;
}

type UseGetByHubLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetByHubResponseType>,
    References.GetByHubRequestType,
    T extends true
      ? Record<'getByHub', References.GetByHubResponseType>
      : References.GetByHubResponseType
  >;

export function useGetByHubLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetByHubResponseType>,
    References.GetByHubRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByHubLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BY_HUB_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByHub: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetByHubLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetByHubLazyQueryReturn<T>;
}

type UseGetByHubSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetByHubResponseType>,
    References.GetByHubRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getByHub', References.GetByHubResponseType>
    : References.GetByHubResponseType;
};

export function useGetByHubSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetByHubResponseType>,
    References.GetByHubRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByHubSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(Queries.GET_BY_HUB_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getByHub: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByHubSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetByHubSuspenseQueryReturn<T>;
}

type UseGetByHubWithHierarchyQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetByHubWithHierarchyResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getByHubWithHierarchy',
            References.GetByHubWithHierarchyResponseType
          >
        : References.GetByHubWithHierarchyResponseType)
    | undefined;
};

export function useGetByHubWithHierarchyQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetByHubWithHierarchyResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByHubWithHierarchyQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_BY_HUB_WITH_HIERARCHY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByHubWithHierarchy: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByHubWithHierarchyQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetByHubWithHierarchyQueryReturn<T>;
}

type UseGetByHubWithHierarchyLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetByHubWithHierarchyResponseType>,
    {},
    T extends true
      ? Record<
          'getByHubWithHierarchy',
          References.GetByHubWithHierarchyResponseType
        >
      : References.GetByHubWithHierarchyResponseType
  >;

export function useGetByHubWithHierarchyLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetByHubWithHierarchyResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByHubWithHierarchyLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BY_HUB_WITH_HIERARCHY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByHubWithHierarchy: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetByHubWithHierarchyLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetByHubWithHierarchyLazyQueryReturn<T>;
}

type UseGetByHubWithHierarchySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetByHubWithHierarchyResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getByHubWithHierarchy',
        References.GetByHubWithHierarchyResponseType
      >
    : References.GetByHubWithHierarchyResponseType;
};

export function useGetByHubWithHierarchySuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetByHubWithHierarchyResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByHubWithHierarchySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_BY_HUB_WITH_HIERARCHY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getByHubWithHierarchy: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByHubWithHierarchySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetByHubWithHierarchySuspenseQueryReturn<T>;
}

type UseGetAccessibleByPortalUserQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAccessibleByPortalUserResponseType>,
    References.GetAccessibleByPortalUserRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAccessibleByPortalUser',
            References.GetAccessibleByPortalUserResponseType
          >
        : References.GetAccessibleByPortalUserResponseType)
    | undefined;
};

export function useGetAccessibleByPortalUserQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAccessibleByPortalUserResponseType>,
    References.GetAccessibleByPortalUserRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAccessibleByPortalUserQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_ACCESSIBLE_BY_PORTAL_USER_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAccessibleByPortalUser: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAccessibleByPortalUserQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAccessibleByPortalUserQueryReturn<T>;
}

type UseGetAccessibleByPortalUserLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAccessibleByPortalUserResponseType>,
    References.GetAccessibleByPortalUserRequestType,
    T extends true
      ? Record<
          'getAccessibleByPortalUser',
          References.GetAccessibleByPortalUserResponseType
        >
      : References.GetAccessibleByPortalUserResponseType
  >;

export function useGetAccessibleByPortalUserLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAccessibleByPortalUserResponseType>,
    References.GetAccessibleByPortalUserRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAccessibleByPortalUserLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_ACCESSIBLE_BY_PORTAL_USER_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAccessibleByPortalUser: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAccessibleByPortalUserLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAccessibleByPortalUserLazyQueryReturn<T>;
}

type UseGetAccessibleByPortalUserSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAccessibleByPortalUserResponseType>,
    References.GetAccessibleByPortalUserRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getAccessibleByPortalUser',
        References.GetAccessibleByPortalUserResponseType
      >
    : References.GetAccessibleByPortalUserResponseType;
};

export function useGetAccessibleByPortalUserSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAccessibleByPortalUserResponseType>,
    References.GetAccessibleByPortalUserRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAccessibleByPortalUserSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_ACCESSIBLE_BY_PORTAL_USER_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAccessibleByPortalUser: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAccessibleByPortalUserSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAccessibleByPortalUserSuspenseQueryReturn<T>;
}

type UseGetAccessibleByPortalUserUniqueQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAccessibleByPortalUserUniqueResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAccessibleByPortalUserUnique',
            References.GetAccessibleByPortalUserUniqueResponseType
          >
        : References.GetAccessibleByPortalUserUniqueResponseType)
    | undefined;
};

export function useGetAccessibleByPortalUserUniqueQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetAccessibleByPortalUserUniqueResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAccessibleByPortalUserUniqueQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_ACCESSIBLE_BY_PORTAL_USER_UNIQUE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAccessibleByPortalUserUnique: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAccessibleByPortalUserUniqueQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAccessibleByPortalUserUniqueQueryReturn<T>;
}

type UseGetAccessibleByPortalUserUniqueLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAccessibleByPortalUserUniqueResponseType>,
    {},
    T extends true
      ? Record<
          'getAccessibleByPortalUserUnique',
          References.GetAccessibleByPortalUserUniqueResponseType
        >
      : References.GetAccessibleByPortalUserUniqueResponseType
  >;

export function useGetAccessibleByPortalUserUniqueLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAccessibleByPortalUserUniqueResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAccessibleByPortalUserUniqueLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_ACCESSIBLE_BY_PORTAL_USER_UNIQUE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAccessibleByPortalUserUnique: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAccessibleByPortalUserUniqueLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAccessibleByPortalUserUniqueLazyQueryReturn<T>;
}

type UseGetAccessibleByPortalUserUniqueSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetAccessibleByPortalUserUniqueResponseType>
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getAccessibleByPortalUserUnique',
          References.GetAccessibleByPortalUserUniqueResponseType
        >
      : References.GetAccessibleByPortalUserUniqueResponseType;
  };

export function useGetAccessibleByPortalUserUniqueSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAccessibleByPortalUserUniqueResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAccessibleByPortalUserUniqueSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_ACCESSIBLE_BY_PORTAL_USER_UNIQUE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAccessibleByPortalUserUnique: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAccessibleByPortalUserUniqueSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAccessibleByPortalUserUniqueSuspenseQueryReturn<T>;
}

type UseGetByIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getById', References.GetByIdResponseType>
        : References.GetByIdResponseType)
    | undefined;
};

export function useGetByIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_BY_ID_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetByIdQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetByIdQueryReturn<T>;
}

type UseGetByIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType,
    T extends true
      ? Record<'getById', References.GetByIdResponseType>
      : References.GetByIdResponseType
  >;

export function useGetByIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BY_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetByIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetByIdLazyQueryReturn<T>;
}

type UseGetByIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getById', References.GetByIdResponseType>
    : References.GetByIdResponseType;
};

export function useGetByIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(Queries.GET_BY_ID_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetByIdSuspenseQueryReturn<T>;
}

type UseGetByIdsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetByIdsResponseType>,
    References.GetByIdsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getByIds', References.GetByIdsResponseType>
        : References.GetByIdsResponseType)
    | undefined;
};

export function useGetByIdsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetByIdsResponseType>,
    References.GetByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_BY_IDS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetByIdsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetByIdsQueryReturn<T>;
}

type UseGetByIdsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetByIdsResponseType>,
    References.GetByIdsRequestType,
    T extends true
      ? Record<'getByIds', References.GetByIdsResponseType>
      : References.GetByIdsResponseType
  >;

export function useGetByIdsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetByIdsResponseType>,
    References.GetByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetByIdsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetByIdsLazyQueryReturn<T>;
}

type UseGetByIdsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetByIdsResponseType>,
    References.GetByIdsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getByIds', References.GetByIdsResponseType>
    : References.GetByIdsResponseType;
};

export function useGetByIdsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetByIdsResponseType>,
    References.GetByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(Queries.GET_BY_IDS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByIdsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetByIdsSuspenseQueryReturn<T>;
}

type UseCreateMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.CreateResponseType>,
  References.CreateRequestType,
  T extends true
    ? Record<'create', References.CreateResponseType>
    : References.CreateResponseType
>;

export function useCreateMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CreateResponseType>,
    References.CreateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            create: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateMutationReturn<T>;
}

type UseUpdateFatTeamsMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.UpdateFatTeamsResponseType>,
  References.UpdateFatTeamsRequestType,
  T extends true
    ? Record<'updateFatTeams', References.UpdateFatTeamsResponseType>
    : References.UpdateFatTeamsResponseType
>;

export function useUpdateFatTeamsMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateFatTeamsResponseType>,
    References.UpdateFatTeamsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateFatTeamsMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_FAT_TEAMS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateFatTeams: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateFatTeamsMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateFatTeamsMutationReturn<T>;
}

type UseUpdateParentTeamsMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateParentTeamsResponseType>,
    References.UpdateParentTeamsRequestType,
    T extends true
      ? Record<'updateParentTeams', References.UpdateParentTeamsResponseType>
      : References.UpdateParentTeamsResponseType
  >;

export function useUpdateParentTeamsMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateParentTeamsResponseType>,
    References.UpdateParentTeamsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateParentTeamsMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_PARENT_TEAMS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateParentTeams: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateParentTeamsMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateParentTeamsMutationReturn<T>;
}

type UseDeleteTeamsMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.DeleteTeamsResponseType>,
  References.DeleteTeamsRequestType,
  T extends true
    ? Record<'deleteTeams', References.DeleteTeamsResponseType>
    : References.DeleteTeamsResponseType
>;

export function useDeleteTeamsMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DeleteTeamsResponseType>,
    References.DeleteTeamsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDeleteTeamsMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DELETE_TEAMS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            deleteTeams: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDeleteTeamsMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDeleteTeamsMutationReturn<T>;
}

type UseSetPortalUserTeamsStateMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SetPortalUserTeamsStateResponseType>,
    References.SetPortalUserTeamsStateRequestType,
    T extends true
      ? Record<
          'setPortalUserTeamsState',
          References.SetPortalUserTeamsStateResponseType
        >
      : References.SetPortalUserTeamsStateResponseType
  >;

export function useSetPortalUserTeamsStateMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.SetPortalUserTeamsStateResponseType>,
    References.SetPortalUserTeamsStateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSetPortalUserTeamsStateMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SET_PORTAL_USER_TEAMS_STATE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            setPortalUserTeamsState: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSetPortalUserTeamsStateMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSetPortalUserTeamsStateMutationReturn<T>;
}
